var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWebCustomerIconTlink(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlnsCc: "http://creativecommons.org/ns#",
    xmlnsDc: "http://purl.org/dc/elements/1.1/",
    xmlnsInkscape: "http://www.inkscape.org/namespaces/inkscape",
    xmlnsRdf: "http://www.w3.org/1999/02/22-rdf-syntax-ns#",
    xmlnsSodipodi: "http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd",
    xmlnsSvg: "http://www.w3.org/2000/svg",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 16,
    height: 16,
    viewBox: "0 0 28 24",
    style: {
      enableBackground: "new 0 0 16 16"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n .st0{fill:#66E345;}\n .st1{fill:none;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M14.7,13.3c3.3,0,6-2.7,6-6s-2.7-6-6-6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M14.7,1.3c-3.3,0-6,2.7-6,6s2.7,6,6,6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7,27.3h11c0.6,0,1-0.4,1-1v-2c0-5-4-9-9-9h-3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M14.7,15.3h-3c-5,0-9,4-9,9v2c0,0.6,0.4,1,1,1h11"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebCustomerIconTlink);
export default __webpack_public_path__ + "static/media/Web_Customer_Icon_Tlink.dc2da2a5acfec3b988103b1e9151c0a2.svg";
export { ForwardRef as ReactComponent };